import { ApiService } from './services/api'
import '@/scss/components/search.scss'

class Search {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.form = document.forms.search
      this.btnClear = this.form.querySelector('.js-clear')
      this.input = this.form.querySelector('.input')
      this.counter = this.form.querySelector('.js-counter')
      this.results = document.querySelector('#results')
      this.query = ''

      this.init()
    })
  }

  init() {
    const search = new URLSearchParams(window.location.search)
    this.input.value = search.get('query')
    if (this.input.value) this.search()
    else this.input.focus()

    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      this.search()
    })

    this.btnClear.addEventListener('click', () => {
      this.query = ''
      this.input.value = ''
      this.input.focus()
      this.results.innerHTML = ''
      this.counter.classList.add('is-hidden')
      this.btnClear.parentNode.classList.add('is-hidden')
    })
  }

  search() {
    if (this.input.value === this.query) return
    this.btnClear.parentNode.classList.remove('is-hidden')

    return ApiService.search({ query: this.input.value }).then((response) => {
      this.results.innerHTML = response.html
      this.query = this.input.value

      this.counter.classList.toggle('is-hidden', !response.count)
      if (response.count != 0)
        this.counter.innerHTML = response.count + ' rezultate'
    })
  }
}

const search = new Search()
